import { ConvertHelper } from "../../helpers/convert-helper"

import { IJsonSerializable } from "../util/interfaces"

import { OpEnumObject } from "./op-enum-object"


export class OpCurrentCreditInfo implements IJsonSerializable {

    // Properties 

    public currentCredit: number
    public currentCreditColorHex: string
    public balanceFromDevice: number
    public balanceFromDeviceColorHex: string
    public accountValidityTime: Date
    public accountValidityTimeColorHex: string
    public lastCreditUpdate: Date
    public balanceOwed: number

    public valveState: OpEnumObject
    public valveStateColorHex: string

    // Properties End


    // Ctor

    public constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false) {
        if (opObj != null) {
            this.currentCredit = opObj.CurrentCredit
            this.currentCreditColorHex = opObj.CurrentCreditColorHex
            this.balanceFromDevice = opObj.BalanceFromDevice
            this.balanceFromDeviceColorHex = opObj.BalanceFromDeviceColorHex
            this.accountValidityTime = opObj.AccountValidityTime != null ? ConvertHelper.stringToDate(opObj.AccountValidityTime) : null
            this.accountValidityTimeColorHex = opObj.AccountValidityTimeColorHex
            this.lastCreditUpdate = opObj.LastCreditUpdate != null ? ConvertHelper.stringToDate(opObj.LastCreditUpdate) : null
            this.balanceOwed = opObj.BalanceOwed
            this.valveState = opObj.ValveState != null ? new OpEnumObject(opObj.ValveState) : null
            this.valveStateColorHex = opObj.ValveStateColorHex
        }
    }

    public toJSON(compressed: boolean = false) {
        return {
            CurrentCredit: this.currentCredit,
            CurrentCreditColorHex: this.currentCreditColorHex,
            BalanceFromDevice: this.balanceFromDevice,
            BalanceFromDeviceColorHex: this.balanceFromDeviceColorHex,
            AccountValidityTime: this.accountValidityTime != null ? ConvertHelper.dateToString(this.accountValidityTime, { netFormat: true }) : null,
            AccountValidityTimeColorHex: this.accountValidityTimeColorHex,
            LastCreditUpdate: this.lastCreditUpdate != null ? ConvertHelper.dateToString(this.lastCreditUpdate, { netFormat: true }) : null,
            BalanceOwed: this.balanceOwed,
            ValveState: this.valveState != null ? this.valveState.toJSON(compressed) : null,
            ValveStateColorHex: this.valveStateColorHex
        }
    }

    // IJsonSerializable Implementation End
}